export default {"src":"/_next/static/media/money-back.a4b5ba64.svg","height":71,"width":111};